<template>
    <div class="root" ref="rootBg">
        <div class="head">
            <img src="/static/images/pc_head.png" class="imghead" />
            <div class="flexr" style="font-size: 0.1042rem;" v-if="data.realName">
                <span style="width: 100%;text-align: left;">{{ getTimeOfDay() + '好,' + data.realName }},祝你开心每一天</span>

                <div v-show="data.companyId"
                    style="color: #F0F9FF;width: 100%; font-size: 0.0781rem;margin-top: 0.0329rem; text-align: left;">{{ data.deptName
                    }}{{ nameDivider }}
                    {{ data.position }}
                </div>


            </div>
            <div class="flexrb">

            </div>
            <div class="flexr ">
                <span class="ttext">本月创作</span>
                <span class="vtext">{{ data.monthTimes }}</span>
            </div>
            <div class="divider" v-show="data.companyId && data.deptName"></div>
            <div class="flexr" v-show="data.companyId && data.deptName">
                <span class="ttext">团队内排名</span>
                <span class="vtext" v-show="data.userRank">{{ data.userRank }}/{{ data.allUserCount }}</span>
            </div>
            <div class="divider"></div>
            <div class="flexr">
                <span class="ttext">累计创作</span>
                <span class="vtext">{{ data.allTimes }}</span>
            </div>


        </div>
        <div class="table">
            <div class="tab_head">
                <img src="/static/images/welcome_pic.png" class="headImg">
                <span style="flex: 1; text-align: left;"> 创作趋势图</span>
                <div class="daytab">
                    <button :class="curTag === 'day' ? 'tabCheck' : 'tab'" @click="select('day')">今日</button>
                    <button :class="curTag === 'week' ? 'tabCheck' : 'tab'" @click="select('week')">周</button>
                    <button :class="curTag === 'month' ? 'tabCheck' : 'tab'" @click="select('month')"> 月</button>
                    <button :class="curTag === 'year' ? 'tabCheck' : 'tab'" @click="select('year')">年</button>
                </div>
            </div>
            <div class="tableDivider"></div>
            <div class="tab_center">
                <div ref="chart" :class="data.companyId && data.deptName ? ' chart' : 'chartFull'"></div>

                <div class="rank" v-if="data.companyId && data.deptName">
                    <span style="font-size: 0.0833rem; margin-bottom: 0.0521rem;">创作排名</span>
                    <div v-for="item in ranks" :key="item.id" class="rankItem">
                        <div>
                            <div style="display:flex">

                                <img src="/static/images/welcome_1.png" class="rankIcon"
                                    v-if="ranks.indexOf(item) === 0">
                                <img src="/static/images/welcome_2.png" class="rankIcon"
                                    v-else-if="ranks.indexOf(item) === 1">
                                <img src="/static/images/welcome_2.png" class="rankIcon"
                                    v-else-if="ranks.indexOf(item) === 2">
                                <div class="rankIndex" v-else>{{ ranks.indexOf(item) + 1 }}</div>
                                <div style="flex: 1; text-align: left; font-size: 0.0781rem;">{{ item.realName }}</div>
                            </div>
                        </div>
                        <div style="font-size: 0.0781rem ;color: #fff;">{{ item.times }}</div>
                    </div>
                    <div v-if="ranks == null || ranks.length === 0" style="font-size: 0.0729rem;">
                        暂无排行信息
                    </div>
                </div>
            </div>



        </div>
        <div class="tab_bot">
            <span class="indexText">AI创作</span>
            <span class="botIndex"></span>
            <div class="botDivider"></div>
            <div class="worksBg">
                <div class="worksItem" v-for="item in works" :key="item.id" @click="showBig(item)">

                    <img :src="getMixImg(item)" class="itemImg" style="object-fit: contain;" />
                </div>

            </div>
            <div v-if="works.length === 0" class="emptyBg">

                <div class="emptyimg">
                    <img src="/static/images/list_empty.png" style="object-fit: contain;">
                    <span class="emptySpan" style="font-size: 0.0781rem;">还没有创作记录</span>


                </div>
            </div>
        </div>
        <div class="botText" v-if="isPc"> <span style="margin-right: 0.1667rem;color: #a0c9e3;"> <a
                    href="http://beian.miit.gov.cn/" target="_blank">备案号：浙ICP备18030856号</a> </span> Copyright @ 2023.
            All rights reserved.泽玺科技 版权所有.</div>
        <div class="botTextPc" v-else> <span style="margin-right: 0.1667rem;color: #a0c9e3;"> <a
                    href="http://beian.miit.gov.cn/" target="_blank">备案号：浙ICP备18030856号</a> </span> Copyright @ 2023.
            All rights reserved.泽玺科技 版权所有.</div>

        <el-image-viewer style="z-index:1500" v-if="showImageViewer" :on-close="() => { showImageViewer = false }"
            :thumbnail="400" :url-list="imageData" :initial-index="viewerIndex">

        </el-image-viewer>
    </div>
</template>
<script>
import * as echarts from 'echarts'
import { getStatisticsInfo, getRankInfo, getUserInfo } from '@/api/works/photos.js'
import { format } from 'date-fns'
import { getToken } from '@/utils/auth'
import bus from '@/utils/bus'
export default {
    data() {
        return {
            imgsArr: [
            ],
            ranks: [],
            curTag: 'day',
            works: [],
            data: {},
            viewerIndex: 0,
            showImageViewer: false,
            imageData: [],
            isPc: true,
            deviceWidth: 0,
            deviceHeight: 0

        }

    },
    created() {



    },
    computed: {
        nameDivider() {
            return this.data.deptName && this.data.position ? '|' : ' '
        }
    },

    methods: {
        // 获取到对应目录  批处理任务对应 1模特 和 多个被换装图片
        getDeviceDimensions() {
            // 获取设备宽度和高度
            this.deviceWidth = window.innerWidth
            this.deviceHeight = window.innerHeight
            this.isPc = (this.$refs.rootBg.scrollHeight > this.$refs.rootBg.clientHeight)
            // if (this.$refs.rootBg.scrollHeight > this.deviceHeight) {
            //     this.isPc = true
            // }
            // this.$message(this.$refs.rootBg.scrollHeight + 'f  ' + this.$refs.rootBg.clientHeight)
            //  console.log(this.$refs.rootBg.scrollHeight + 'f  ' + this.deviceHeight)
            // this.isPc = true
        },
        select(tag) {
            this.curTag = tag
            this.$forceUpdate()
            this.loadInfo()


        },

        getTimeOfDay() {
            const currentHour = new Date().getHours()

            if (currentHour >= 5 && currentHour < 9) {
                return '早上'
            } else if (currentHour >= 9 && currentHour < 12) {
                return '上午'
            } else if (currentHour >= 12 && currentHour < 18) {
                return '下午'
            } else if (currentHour >= 18 && currentHour < 20) {
                return '傍晚'
            } else if (currentHour >= 20 && currentHour < 24) {
                return '晚上'
            } else {
                return '凌晨'
            }
        },
        getMixImg(item) {
            const url = item.replyMessage
            if (url.indexOf('?') != -1) {
                return item.replyMessage + '/thumbnail/400x/format/webp'
            } else {

                return item.replyMessage + '?imageMogr2/thumbnail/400x/format/webp'
            }

        },
        showBig(item) {
            this.imageData = this.works.map((it, i) => {

                if (it.replyMessage.indexOf('!') > -1) {
                    return it.replyMessage + '/format/webp'
                } else {
                    return it.replyMessage + '?imageMogr2/format/webp'
                }

            })

            this.viewerIndex = this.works.indexOf(item)
            this.showImageViewer = true
        },
        async loadInfo() {
            const userInfo = await getUserInfo()


            this.data = userInfo.data
            if (userInfo.data.works) {
                this.works = userInfo.data.works
            }
            let str
            if (this.curTag === 'day') {
                str = 1
            } else if (this.curTag === 'week') {
                str = 2
            } else if (this.curTag === 'month') {
                str = 3
            } else {
                str = 4
            }

            getStatisticsInfo({ timsStatisticsType: str }).then(res => {
                const data = res.data
                if (str == 1) {
                    // 填充一个24 小时 的数组
                    const riqi = this.get24Hour()

                    for (const r of data) {
                        const formatH = r.useTime.substring(11, 13)
                        for (const d of riqi) {
                            if (d.useTime == formatH) {
                                d.times = r.times
                                break
                            }
                        }
                    }

                    this.setUserInfo(riqi)
                } else if (str == 2) {
                    // 填充七天


                    const riqi = this.getPreviousSevenDays(7)

                    for (const oit of data) {
                        const dstr = oit.useTime.substring(5, 10)
                        for (const it of riqi) {
                            if (it.useTime == dstr) {
                                it.times = oit.times
                            }
                        }
                    }
                    this.setUserInfo(riqi)





                } else if (str == 3) {
                    // 填充30天


                    const riqi = this.getPreviousSevenDays(30)

                    for (const oit of data) {
                        const dstr = oit.useTime.substring(5, 10)
                        for (const it of riqi) {
                            if (it.useTime == dstr) {
                                it.times = oit.times
                                a += it.times
                            }
                        }
                    }



                    this.setUserInfo(riqi)
                } else {
                    // 填充12月

                    const riqi = this.getPrevious12Months()

                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < riqi.length; j++) {
                            if (riqi[j].useTime == data[i].useTime) {
                                riqi[j].times = data[i].times
                                break
                            }
                        }
                    }
                    this.setUserInfo(riqi)

                }

            })
            if (this.data.companyId && this.data.deptName) {
                // 处理排序
                getRankInfo({ timsStatisticsType: str }).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.ranks = res.data.slice(0, 10)
                    }


                })
            }


            // getUserInfo().then(res => { 
            //     this.data = res.data
            //     if (res.data.works) { 
            //         this.works = res.data.works
            //     }

            // })
        },

        getPrevious12Months() {
            const today = new Date() // 获取当前日期
            const currentYear = today.getFullYear() // 获取当前年份
            const currentMonth = today.getMonth() // 获取当前月份（0表示1月，11表示12月）

            const result = [] // 存储前12个月的日期
            for (let i = 0; i < 12; i++) {
                const year = currentYear + Math.floor((currentMonth - i) / 12) // 计算年份
                const month = (currentMonth - i + 12) % 12 // 计算月份（确保在0~11之间）

                result.push({
                    useTime: `${year}-${String(month + 1).padStart(2, '0')}`,
                    times: 0
                }) // 将年份和月份拼接为字符串，并添加到结果数组中
            }

            result.sort((a, b) => new Date(a.useTime) - new Date(b.useTime))


            return result
        },
        get24Hour() {
            const result = []
            for (let i = 0; i < 24; i++) {
                result.push({
                    useTime: i < 10 ? ('0' + i) : (i + ''),
                    times: 0
                })
            }
            return result
        },

        getPreviousSevenDays(lastDay) {
            const today = new Date() // 获取当前日期
            const sevenDaysAgo = new Date(today) // 创建一个新的日期对象
            sevenDaysAgo.setDate(today.getDate() - lastDay + 1) // 将日期设置为前7天

            const result = [] // 存储前7天的日期
            for (let i = 0; i < lastDay; i++) {

                //  const d = new Date(format(new Date(sevenDaysAgo), 'MM-dd'))

                result.push({
                    useTime: format(new Date(sevenDaysAgo), 'MM-dd'),
                    times: 0
                })// 将日期对象添加到结果数组中
                sevenDaysAgo.setDate(sevenDaysAgo.getDate() + 1) // 递增一天

            }

            return result
        },
        setUserInfo(info) {


            const xData = info.map((it, i) => { return it.useTime })
            const yData = info.map((it, i) => { return it.times })

            const chartDom = this.$refs.chart
            const myChart = echarts.init(chartDom) // 初始化图表实例
            //  myChart.getDom().style.width = '600px';
            // myChart.getDom().style.height = '400px';

            // // 调用 resize() 方法重新渲染图表
            myChart.resize()
            // this.loadInfo()
            // 设置图表的数据和配置
            const option = {

                title: {
                    text: '水果销量柱状图', // 图表标题
                    left: 'center', // 标题位置
                    show: false
                },

                grid: {
                    left: '5%',
                    right: '5%',
                    top: '12%',
                    bottom: '4%',

                    containLabel: true,
                    backgroundColor: 'transparent', // 设为透明，以便背景矩形能够显示
                    graphic: [
                        {
                            type: 'rect',
                            left: 'center',
                            top: 'center',
                            z: -1, // 放在最底层
                            shape: {
                                width: '80%',
                                height: '80%'
                            },
                            style: {
                                fill: '#f5f5f5' // 设置背景颜色
                            }
                        }
                    ]

                },

                //  grid: {
                //     left: '40px',
                //     right: '0px',
                //     top: '20px',
                //     bottom: '20px',
                //     containLabel: true
                // },
                xAxis: {
                    type: 'category', // X 轴类型为类目轴
                    data: xData, // X 轴标签，表示水果种类
                    color: '#EEF9FF',
                    axisLabel: {
                        rotate: xData.length > 12 ? 45 : 0, // 旋转角度，以度为单位
                        fontSize: this.rem(12), // 设置字体大小为12
                        interval: 0 // 0 表示全部显示，可以设置为其他数值以控制显示间隔

                    }


                },
                yAxis: {
                    type: 'value', // Y 轴类型为数值轴
                    name: ' ', // Y 轴名称
                    nameTextStyle: {
                        fontSize: this.rem(12) // 设置 y 轴名称的字体大小为 14px
                    },
                    nameLocation: 'end', // Y 轴名称位置
                    axisLine: {
                        lineStyle: {

                            color: '#EEF9FF' // Y 轴轴线颜色

                        }
                    },
                    splitLine: {
                        lineStyle: {

                            type: 'dashed', // 将 Y 轴标准背景线样式设为虚线
                            color: '#3F4559'
                        }
                    },
                    axisLabel: {

                        fontSize: this.rem(12) // 设置字体大小为12


                    }


                },

                series: [
                    {
                        type: 'bar', // 图表类型为柱状图
                        barWidth: '20%', // 设置柱状图的宽度为 30%
                        data: yData, // Y 轴数据，表示每种水果的销量
                        itemStyle: {
                            color: '#00D0FF', // 柱状图颜色
                            backgroundColor: '#000',
                            barBorderRadius: 10 // 设置圆角的大小为 10
                        },
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置：顶部

                            textStyle: {
                                fontSize: '10'
                            }

                        }



                    }
                ]

            }

            // 将配置项设置到图表中

            myChart.setOption(option)
            //  myChart.resize()
            // this.$forceUpdate()
        },


        rem(px) {
            return `${px / 192}rem`
        }
    },
    beforeDestroy() {
        bus.$off('loginSucess')
    },
    mounted() {



        if (getToken()) {
            this.loadInfo()

        } else {
            this.$message('请先登录')
            bus.$emit('showLogin')
        }

        bus.$on('loginSucess', call => {
            this.loadInfo()

        })

        // 在组件加载后获取设备宽度和高度
        this.getDeviceDimensions()

    },
    components: {
        'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
    position: relative;
    width: calc(100% - 40px);
    padding: 20px 20px 0 20px;
    color: #F0F9FF;
    font-size: 14px;
    overflow-y: auto;
    background: #000
}

.root::-webkit-scrollbar {
    display: none;
}

.tab_bot {
    display: flex;
    margin-top: 8px;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.indexText {
    color: #EFF8FF;
    font-size: 18px;
    width: 110px;
}

.botIndex {
    margin-top: 10px;
    width: 110px;
    height: 4px;
    background: linear-gradient(172deg, #0CE1F9 0%, #701EFE 100%);
}

.botDivider {
    width: 100%;
    height: 1px;
    background: #45455E;
}

.tableDivider {
    width: calc(100% - 80px);
    margin-left: 40px;
    margin-right: 40px;
    height: 1px;
    margin-bottom: 12px;
    background: #45455E;
}

/* .worksBg {
    margin-top: 14px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
} */


.worksBg {
    margin-top: 14px;
    width: 100%;
    display: grid;
    align-items: center;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 240px);
    grid-column-gap: 26px;

}

.works {
    width: 100%;
    justify-content: space-between;
    display: flex;

}

.emptyimg {
    align-self: center;
    width: 232px;
    margin-top: 24px;
    position: relative;

}

.emptyBg {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.emptyimg img {
    width: 232px;
    height: 232px;
    object-fit: contain;

}

.emptySpan {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
}

.botTextPc {
    font-size: 14px;
    margin-top: 40px;
    margin-bottom: 24px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    color: #A4AAB9;

}

.botText {
    font-size: 14px;
    margin-top: 40px;
    margin-bottom: 24px;
    color: #A4AAB9;

}

.worksItem {
    /* flex: 0 0 auto;
    不增长，不缩小，初始宽度自适应 */
    width: 240px;
    height: 240px;


}


.itemImg {
    width: 100%;
    height: 100%;
    border-radius: 10px;
}

.table {
    margin-top: 20px;
    height: 367px;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #141825;
    border-radius: 20px;
}

.chartFull {
    width: 100%;
    height: 264px;

}

/* .chartFull{
    width: 1151px;
    height: 264px;
} */

.chart {
    width: 1251px;
    height: 264px;
}

.tab_center {
    display: flex;
    align-items: center;
    height: 264px;
    justify-content: flex-start;
}

.daytab {
    display: flex;
    justify-content: center;
    background: #20263B;
    height: 44px;
    align-items: center;
    border-radius: 12px;
    padding-left: 6px;
    padding-right: 6px;


}

button {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    outline: none;
}

.tabCheck {
    background: #121520;
    width: 65px;

    height: 34px;
    line-height: 34px;
    color: #fff;
    border-radius: 10px;
    font-size: 15px;
    text-align: center;
}

.tab {

    width: 65px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    font-size: 15px;
    text-align: center;
}

.rank {
    margin-right: 51px;
    align-self: flex-start;
    width: 300px;
    margin-left: 30px;
    display: flex;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

}

.vtext {
    font-size: 22px;
    margin-top: 14px;
    color: #0BE2F9;
}

a {
    outline: none;
    color: inherit;
    /* 继承父元素的文本颜色 */
    text-decoration: none;
    /* 去除下划线 */
}

.ttext {
    font-size: 15px;
    color: #FFFFFF;
}



.rankItem {
    display: flex;
    align-items: center;
    width: 100%;
    height: 30px;
    justify-content: space-between;
}

.rankIndex {
    font-size: 12px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 10px;
    background: #2A355F;
    margin-right: 14px;

}

.rankIcon {
    width: 20px;
    height: 20px;
    margin-right: 14px;
}

.flexr {
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.flexrb {
    flex: 1;
}

.divider {
    width: 1px;
    height: 43px;
    margin-left: 6px;
    margin-right: 6px;
    background: #3F4559;
}

.tab_head {
    display: flex;
    align-items: center;
    padding-left: 40px;
    padding-right: 40px;
    justify-content: flex-start;
    height: 65px;
}

.head {
    height: 110px;
    padding-left: 24px;
    padding-right: 24px;
    background: #141825;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
}

.headImg {
    width: 21px;
    height: 18px;
    margin-right: 14px;
}

.imghead {
    width: 62px;
    height: 62px;
}
</style>



// WEBPACK FOOTER //
// src/views/welcome/index.vue